const capitalize = require('capitalize');

// I could find no restrictions on parameter names in Swagger, so I will
// assume they are all valid, and that `:` denotes a regex, e.g.
// `{banana:[a-z]}`.  The regex below will match any set of characters
// within brackets {}, but has an optional, non-capturing group that starts
// with `:`.
const reSwaggerParam = /{(.+?)(?::.*?)?}/g;
const reParamName = /[^a-zA-Z0-9]/g;

/**
 * Method to create custom operationID-like operation id. Taken from
 * connectors team

 * NOTE: duplicated from code in @axway/api-builder-oas-flow-node/src/utils/generateFunctionName.js
 * NOTE: which was in turn duplicated from code from arrow-admin-api/src/openapi-utils.js,
 * @param  {string} method - The method/verb (eg. "GET")
 * @param  {string} path   - The path (eg. /thing)
 * @return {string} The custom operationID
 */
function generateFunctionName(method, path) {
	const preserveOriginalCapitalization = true;
	const parts = path.split(/\//g);
	if (parts.length && parts[0] === '') {
		parts.shift();
	}
	const parsed = parts.reduce((acc, cur) => {
		if (cur.startsWith('{')) {
			reSwaggerParam.lastIndex = 0;
			const match = reSwaggerParam.exec(cur);
			reParamName.lastIndex = 0;
			match[1].split(reParamName).forEach(a => {
				acc.params.push(capitalize(a, preserveOriginalCapitalization));
			});
		} else {
			reParamName.lastIndex = 0;
			cur.split(reParamName).forEach(a => {
				acc.slugs.push(capitalize(a, preserveOriginalCapitalization));
			});
		}
		return acc;
	}, {
		slugs: [],
		params: []
	});
	if (!parsed.params.length) {
		return method.toLowerCase() + parsed.slugs.join('');
	} else {
		return `${method.toLowerCase()}${parsed.slugs.join('')}By${parsed.params.join('')}`;
	}
}

function getOpenAPIAuthSettings(auth) {
	const settings = {
		httpConfig: undefined,
		apiKeyConfig: undefined,
		authorization: false
	};

	// prefill the current auth strategy if we know how
	if (auth.apiPrefixSecurity === 'basic') {
		// We know this from the built-in headerauthbasic auth strategy
		settings.httpConfig = {
			definitionKey: 'basicAuth',
			username: auth.apikey,
			password: ''
		};
	} else if (auth.apiPrefixSecurity === 'apikey') {
		// We know this from the built-in headervalue auth strategy
		settings.apiKeyConfig = {
			definitionKey: 'apikey',
			value: auth.apikey
		};
	} else if (auth.apiPrefixSecurity !== 'none') {
		// Enable the Authorize button to let the user fill it in themselves
		// since we don't know how to do it automatically. (plugin, ldap)
		settings.authorization = true;
	}
	return settings;
}

module.exports = {
	generateFunctionName,
	getOpenAPIAuthSettings
};
